import { apiClient } from '@/infrastructure/api'
import {
  ReturnsApi,
  ReturnsApiAvailableRefundMethodChangeOptionsRequest,
  ReturnsApiCalculateUpdateAmountRequest,
  ReturnsApiUpdateReturnProcessRequest
} from '@itsrever/rever-api'

export const returnsApi = new ReturnsApi(undefined, undefined, apiClient)

export async function getAvailableRefundMethods(
  req: ReturnsApiAvailableRefundMethodChangeOptionsRequest
) {
  const response = await returnsApi.availableRefundMethodChangeOptions(req)

  return response.data
}

export async function calculateRefundAmountUpdate(
  req: ReturnsApiCalculateUpdateAmountRequest
) {
  const response = await returnsApi.calculateUpdateAmount(req)

  return response.data
}

export async function updateReturnProcess(
  req: ReturnsApiUpdateReturnProcessRequest
) {
  const response = await returnsApi.updateReturnProcess(req)

  return response.data
}
